import { Form } from 'react-bootstrap';

import { profileApi } from '@reducers/profile/profile';

export const DocumentsFilter = ({ profileID, setProfileID }) => {
  const profiles = profileApi.useGetForSelectQuery();
  const handleChange = (e) => {
    setProfileID(e.target.value);
  };
  return (
    <>
      <Form.Label>Documents belonging to:</Form.Label>
      <Form.Select onChange={(e) => handleChange(e)} value={profileID || ''}>
        <option value="">Select end user</option>
        {profiles.isLoading ? <option>Loading...</option> : null}
        {!profiles.isLoading
          ? profiles.data.map((option) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))
          : null}
      </Form.Select>
    </>
  );
};
